@if(isDisabled){
<app-loader></app-loader>
}
<div class="m-2">
    <div class="row pb-2">
        <div class="col"></div>
        <div class="col-auto">
            <button *ngIf="this.common.PageRight.IsAdd" type="button" class="btn btn-primary" [disabled]="isDisabled"
                (click)="add(0,'','',null)">
                <i class="bi bi-plus-lg" *ngIf="!isDisabled"></i>
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                    *ngIf="isDisabled"></span>
                {{!isDisabled?'Add Cluster':'Loading...'}}
            </button>
        </div>
    </div>
    <div class="card border-radius-0 mt-1 p-0">
        <div class="card-header">
            Cluster Master
        </div>
        <div class="card-body p-1" style="width: 100%; overflow: auto;">
            <table datatable [dtOptions]="this.dtoptions" [dtTrigger]="dtTrigger" class="customeDatatable table table-bordered">
                <thead class="table-light">
                    <tr>
                        <th style="width: 5px;">#</th>
                        <th>Cluster Name</th>
                        <th>Cluster Code</th>
                        <th>Branch Name</th>
                        <th style="width: 5px;" [ngClass]="{'colHide': !this.common.PageRight.IsEdit}">Action</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let element of TableDatas; let i = index">
                        <th scope="row">{{ i + 1 }}</th>
                        <td> {{element['ClusterName']}}</td>
                        <td> {{element['ClusterCode']}}</td>
                        <td> {{element['BranchName']}}</td>
                        <td style="width: 5px;" [ngClass]="{'colHide': !this.common.PageRight.IsEdit}">
                            <div class="text-center"><i
                                    (click)="add(element['ESS_ClusterMasterID'],element['ClusterCode'],element['ClusterName'],element['BranchID'])"
                                    class="bi bi-pencil-square text-warning"></i></div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <!-- <div class="card-footer">
            <div class="row">
                <div class="col">

                    <div class="row">
                    </div>
                    <div class="row">
                    </div>
                </div>
                <div class="col-auto">
                    <button  class="btn btn-sm btn-primary" name="sample"  >
                        <i class="bi bi-file-earmark-arrow-down" *ngIf="!isDisabled"></i>
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                            *ngIf="isDisabled"></span>
                        {{!isDisabled?'Excel':'Loading...'}}
                    </button> 
                </div>
            </div>
        </div> -->
    </div>
</div>